// TODO: tymczasowa implementacja na localStorage (BE `POST /api/ui/sales-crm/filters` nie istnieje, zwraca 404).
// Docelowo wrocic do wywolan HTTP aby presety synchronizowaly sie miedzy urzadzeniami tradera.

import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';
import {
  getSalesCrmFiltersQueryKey,
  readSalesCrmFiltersFromStorage,
  writeSalesCrmFiltersToStorage,
  ISalesCrmFilterPreset
} from 'api/endpoints/useGetSalesCrmFilters';

export interface IPostSalesCrmFiltersRequest {
  component_symbol: string;
  name: string;
  filters: IWiseTableAdvancedFilter[];
  column_visibility?: Record<string, boolean>;
  column_order?: string[];
}

type IResponse = ICommandResponseSuccess;

const postSalesCrmFilters = (data: IPostSalesCrmFiltersRequest): Promise<IResponse> => {
  const items = readSalesCrmFiltersFromStorage(data.component_symbol);
  const nextId = items.reduce((max, i) => (i.id > max ? i.id : max), 0) + 1;
  const preset: ISalesCrmFilterPreset = {
    id: nextId,
    name: data.name,
    filters: data.filters,
    column_visibility: data.column_visibility,
    column_order: data.column_order
  };
  writeSalesCrmFiltersToStorage(data.component_symbol, [...items, preset]);
  return Promise.resolve({
    fields_info: [],
    message: '',
    show_message: false,
    status: 1
  });
};

export const usePostSalesCrmFilters = (
  componentSymbol: string,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmFiltersRequest>
) => {
  const queryClient = useQueryClient();
  return useMutation((data: IPostSalesCrmFiltersRequest) => postSalesCrmFilters(data), {
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(getSalesCrmFiltersQueryKey(componentSymbol));
      options?.onSuccess?.(...args);
    }
  });
};
